// Lista de sistemas Zopone no botão de acesso rápido do header.
// Pra adicionar sistema novo: só incluir um objeto aqui, o dropdown lê essa lista.
// Clique abre o link em outra aba. TODO: trocar url de exemplo pela URL real de cada sistema.
export default [
  {
    nome: 'APR',
    url:
      'https://s3.us-east-1.amazonaws.com/app.zopone.com.br/_apk/apr-producao.apk'
  },
  {
    nome: 'QMA',
    url:
      'https://s3.us-east-1.amazonaws.com/app.zopone.com.br/_apk/qma-producao-1.0.35.apk'
  },
  {
    nome: 'Caderneta Digital',
    url:
      'https://play.google.com/store/apps/details?id=com.zopone.caderneta.mobile'
  },
  {
    nome: 'MeuZ',
    url:
      'https://play.google.com/store/apps/details?id=br.com.zopone.meuhmlg&hl=pt_BR'
  },
  {
    nome: 'ZCorretor',
    url:
      'https://play.google.com/store/apps/details?id=br.com.zopone.zcorretor&hl=pt_BR'
  },
  {
    nome: 'CopMobile (Legado)',
    url:
      'https://downloads.zopone.com.br/atualizacao/APPCOP/Android14-15/Zopone.apk'
  }
]



// WEBPACK FOOTER //
// ./src/config/apps-download.js